const apiUrl = process.env.REACT_APP_API_URL;

export const GetJavamonConfig = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/admin/config`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener la configuracion de Javamon:', error);
        return null;
    }
};

export const GetRandomJavamon = async (season?: string, userId?: string) => {
    try {
        let qs = "";
        if (season || userId) {
            const params = new URLSearchParams();
            if (season) params.append("season", season);
            if (userId) params.append("userId", userId);
            qs = "?" + params.toString();
        }
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/random${qs}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener Javamon aleatorio:', error);
        return null;
    }
};

export const PostJavamonSeason = async (body: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/admin/season`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar temporada:', error);
        return null;
    }
};

export const PostJavamonRarity = async (body: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/admin/rarity`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar rareza:', error);
        return null;
    }
};

export const PostJavamonItem = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/admin/javamon`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar javamon:', error);
        return null;
    }
};

export const getJavamonImage = (jm: any): string => {
    if (!jm) return "";

    // If jm is just a string (legacy/filename)
    if (typeof jm === 'string') {
        if (jm.startsWith('data:')) return jm;
        const clean = jm.replace(/^\/?images\/javamon\//, "");
        return `/images/javamon/${clean}`;
    }

    if (jm.id || jm.id_item) {
        //console.log("JM DEBUG:", JSON.stringify(jm));
        const isShopItem = jm.cost !== undefined || jm.stock !== undefined || jm.punts !== undefined || jm.ball !== undefined || (jm.tipo !== undefined && jm._type !== 'magia' && jm.type !== 'magia');
        // Coaccionem a string: _type/type poden arribar com a número (id de tipus) des del backend,
        // i llavors typeSegment.toLowerCase() peta en filtrar la taula d'items.
        let typeSegment = String(jm._type || jm.type || 'javamon');
        let idToUse = jm.id_item || jm.id_game_item || jm.id;

        // Si sabemos que es un shop item, intentamos mapear su type real a la tabla correspondiente si tiene id_item
        if (isShopItem && (jm.id_item || jm.id_game_item)) {
            if (typeSegment === 'weapon') typeSegment = 'arma';
            else if (typeSegment === 'shield') typeSegment = 'escut';
            else if (typeSegment === 'bow') typeSegment = 'arc';
            else if (typeSegment === 'JAVAmon') typeSegment = 'javamon';
            else if (typeSegment === 'ability' || typeSegment === 'magic') typeSegment = 'magia';
            else if (typeSegment === 'arrow') typeSegment = 'flecha';
            else if (typeSegment === 'consumable') typeSegment = 'shop'; // Consumables are probably in shop
            else if (!['skin', 'avatar', 'flecha', 'magia', 'arma', 'escut', 'arc'].includes(typeSegment)) {
                typeSegment = 'shop';
            }
        } else if (isShopItem) {
            typeSegment = 'shop';
        } else {
            if (typeSegment === 'weapon') typeSegment = 'arma';
            if (typeSegment === 'shield') typeSegment = 'escut';
            if (typeSegment === 'bow') typeSegment = 'arc';
            if (typeSegment === 'JAVAmon') typeSegment = 'javamon';
            if (typeSegment === 'ability' || typeSegment === 'magic') typeSegment = 'magia';
            if (typeSegment === 'arrow') typeSegment = 'flecha';
        }

        return `${process.env.REACT_APP_API_URL}:8061/jutge/game/image/${typeSegment.toLowerCase()}/${idToUse}`;
    }

    return "";
};

export const GetTrofeos = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trofeos`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener trofeos:', error);
        return null;
    }
};

export const PostTrofeo = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trofeo`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar trofeo:', error);
        return null;
    }
};

export const TestTrofeoCondition = async (reqType: string, reqValue: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trofeo/test`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ req_type: reqType, req_value: reqValue })
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al probar condicion trofeo:', error);
        return null;
    }
};

export const ExecuteTrofeoJob = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/trofeo/${id}/execute`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al ejecutar trofeo:', error);
        return null;
    }
};

export const GetUsuarioTrofeos = async (idUsuari: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuario/${idUsuari}/trofeos`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener trofeos del usuario:', error);
        return null;
    }
};

export const GetSkins = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener skins:', error);
        return null;
    }
};

export const GetInteractables = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/interactables`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error in GetInteractables:', error);
        return null;
    }
};

export const GetSceneActivities = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-activities`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error in GetSceneActivities:', error);
        return null;
    }
};

export const PostSceneActivity = async (data: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-activities`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in PostSceneActivity:', error);
        return false;
    }
};

export const DeleteSceneActivity = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-activities/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in DeleteSceneActivity:', error);
        return false;
    }
};

export const PostInteractable = async (data: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/interactables`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in PostInteractable:', error);
        return false;
    }
};

export const DeleteInteractable = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/interactables/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in DeleteInteractable:', error);
        return false;
    }
};

export const PostSkin = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/skin`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar skin:', error);
        return null;
    }
};

export const PostArma = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/arma`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar arma:', error);
        return null;
    }
};

export const PostEscut = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/escut`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar escudo:', error);
        return null;
    }
};

export const PostArc = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/arc`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar arco:', error);
        return null;
    }
};

export const PostFlecha = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/flecha`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar flecha:', error);
        return null;
    }
};

export const PostMagia = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skin/magia`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar magia:', error);
        return null;
    }
};

export const PostAvatar = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/avatar`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar avatar:', error);
        return null;
    }
};

export const GetUsersEquipment = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/users`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener equipamiento de usuarios:', error);
        return null;
    }
};

export const PostUserEquipment = async (body: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user-equipment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al guardar equipamiento de usuario:', error);
        return null;
    }
};

/** Desbloquea un item individual para un usuario */
export const UnlockUserItem = async (userId: number, type: string, itemId: number): Promise<boolean> => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user/${userId}/unlock/${type}/${itemId}`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al desbloquear item:', error);
        return false;
    }
};

/** Bloquea (quita el desbloqueo de) un item individual para un usuario */
export const LockUserItem = async (userId: number, type: string, itemId: number): Promise<boolean> => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user/${userId}/unlock/${type}/${itemId}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al bloquear item:', error);
        return false;
    }
};

/** Equipa o desequipa (null) un slot específico del usuario */
export const SetUserEquipped = async (userId: number, field: string, value: number | null): Promise<boolean> => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user/${userId}/equipped/${field}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value })
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error al equipar item:', error);
        return false;
    }
};

export const GetUserUnlockedAvatars = async (userId: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user/${userId}/unlocked-avatars`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener avatares desbloqueados:', error);
        return null;
    }
};

export const GetUserEquipment = async (userId: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/skins/user/${userId}/equipment`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener equipamiento del usuario:', error);
        return null;
    }
};


// ============================================================
// Nombre visible de escenas (display name global por escena)
// ============================================================
export const GetSceneNames = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-names`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error in GetSceneNames:', error);
        return null;
    }
};

export const PostSceneName = async (data: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-names`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in PostSceneName:', error);
        return false;
    }
};

export const DeleteSceneName = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/admin/game/scene-names/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return true;
    } catch (error) {
        console.error('Error in DeleteSceneName:', error);
        return false;
    }
};

export const GetRewardsUsageOverview = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/recompensas/usage-overview`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error in GetRewardsUsageOverview:', error);
        return null;
    }
};


export const GetRewardsHistory = async () => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/recompensas/history`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error in GetRewardsHistory:', error);
        return null;
    }
};
